import API from "../store/api";
import { authLogin, authLogout } from '../store/actions/authActions';
import { setMessage } from '../store/actions/dialogActions';

export const ssoLogin = (query, mobile, normal, errorFunc) => {
  return async dispatch => {
    API.get("/redirect?" + query)
      .then((response) => {
        if (response?.body?.mobile) {
          mobile(response.body);
        } else {
          dispatch(authLogin(response.body));
          normal()
        }
      }).catch((error) => {
        let message = 'An error has occurred';
        if (error.message) {
          message = error.message;
        }
        if (error.response && error.response.body) {
          if (error.response.body.messages) {
            message = error.response.body.messages.toString();
          } 
        }
        dispatch(setMessage({
          title: 'Login Failed',
          message: message,
          type: 'ERR',
        }))
        dispatch(authLogout);
        errorFunc();
      })
  }
}